import _TextInput from './TextInput';

const TextInput = _TextInput;

export default TextInput;



// WEBPACK FOOTER //
// ./components/TextInput/index.js